import React from "react";

function Footer() {
    return (
        <>
            <footer id="footer" className="footer">
                <div className="footer-bottom bg_dark_black" style={{}}>
                    <div className="container-xl">
                        <div className="row">
                            <div className="col-lg-4">
                                <img src={require ('../../assets/images/logo_text.png')} />
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}

export default Footer;